// Auto-fit helper for the patient welcome greeting. The board is a fixed
// 1920×1080 stage, so a long patient name (e.g. "คุณนันทวัฒน์ภณ เหมสมัน") would
// overflow the column at the base font size and wrap mid-word — Thai has no
// spaces, so the browser line-breaks anywhere. The display keeps the name on a
// single unbroken line (white-space: nowrap) and shrinks the font just enough
// to fit. We only ever shrink, never grow past the base size.
//
// Pure math is isolated here so it can be unit-tested without DOM layout
// (jsdom doesn't compute scrollWidth). The component measures widths and feeds
// them in; see welcomeFit.spec.js.

// Given the base font size, the width available to the name, and the name's
// measured width AT THE BASE SIZE, return the font size (px) that makes the
// name fit. Width scales ~linearly with font size, so one measurement is
// enough. Never returns above `baseSize` or below `minSize`.
export function fitFontSize(baseSize, availableWidth, contentWidth, minSize = 64) {
  if (!availableWidth || !contentWidth || contentWidth <= availableWidth) {
    return baseSize;
  }
  const scaled = Math.floor(baseSize * (availableWidth / contentWidth));
  return Math.max(minSize, Math.min(baseSize, scaled));
}
